import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
@Component({
  selector: 'app-userlv',
  templateUrl: './userlv.component.html',
  styleUrls: ['./userlv.component.css']
})
export class UserlvComponent implements OnInit {

  constructor(
    public httpClient: HttpClient,
  ) { }




  
  search_model:string = '';
  now:string = '1';
  subnow:string = '1';

  sort_obj:any = {column:'last_round_diamond',sort:'0'}
  data:any=[];
  tool_list:any={active_list:[],type_list:[],type_list_option_list:[]};
  detail_obj = {diamond_start:0,diamond_end:100000,once_reward:0,name:'',real_info:'1'};
  edit_data:any={id:-1,lv:1,name:'',can_choose_show:'1',gender:'2',real_info:'1',detail:[{ ...this.detail_obj }],status:1,tid:'1',aid:'1',past_aid:'1',
  dead_line_date:'2023-03-06',start_count_date:'2023-03-06',has:"0",recount_month:"0"}
  loading:boolean=true;
  pageobj:page = {page:0,count:30,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))

  ngOnInit(): void {
    this.init_edit_data();

  }


  init_edit_data(){
 
    const today = new Date();
    let formattedDate = today.toISOString().slice(0, 10);
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
    const target = nextMonth.toISOString().slice(0, 10);
    this.edit_data={id:-1,lv:1,name:'',gender:'2',can_choose_show:'1',real_info:'1',detail:[{ ...this.detail_obj }],status:1,tid:'1',aid:'1',past_aid:'1',
    dead_line_date:target,start_count_date:formattedDate,has:"0",recount_month:"0"}
    this.init_list();
  }
  

  recaculate(){
    this.edit_data.detail.map((obj, index) => {
      if (index > 0) {
        obj.diamond_start = index === 0 ? obj.diamond_start : this.edit_data.detail[index-1].diamond_end + 1;
        obj.diamond_end = Math.max(obj.diamond_start + 1, obj.diamond_end);
      }
      return obj;
    });
  }

  rename(){
    if(this.edit_data.name.length>0){
      this.edit_data.detail.map((obj, index) => {
        obj.name = `${this.edit_data.name}${index+1}級`;
        return obj;
      });
    }else{
      alert('請檢察名稱');
    }
  }

  copy(item){
    this.edit_data = item;
    this.edit_data.has = "0";
    this.edit_data.id = -1;
    this.ck_type_list();
  }


  save(){
    let status = true;
    let msg = '儲存成功';
    if(this.edit_data.name.length == 0){
      msg = '請填寫名稱';
      status = false;
    }else{
      status = this.edit_data.detail.every(obj => obj.name.length > 0);
      if(!status){
        msg = '請填寫等級名稱';
      }
    }
   

    if(!status){
      alert(msg);
    }else{
      this.loading = true;
      const body = {data:this.edit_data};
      this.httpClient.post<any>("/update_user_rank.php",body).subscribe(res => {
        this.loading = false;
        if(res.status){
          alert('儲存成功');
        }else{
          alert(res.message);
        }
        this.init_list();
        console.log('save',res);

      });
    }

  }

  ck_type_list(){
    this.tool_list.type_list_option_list = this.tool_list.type_list.filter((v)=>{
      return this.edit_data.gender == v.gender || v.gender == '0';
    }) 
  }

  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,
    type:this.now,
    sort_obj:this.sort_obj,
    search_model:this.search_model,
    };
    this.httpClient.post<any>("/get_user_rank.php",body).subscribe(res => {
      this.loading = false;
    
      this.tool_list.active_list = res.active_list
      this.tool_list.type_list = res.type_list
    

      if(res.status){
        this.data = res.data
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.ck_type_list();
      console.log(res);
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  add_new(){
    const obj = {...this.detail_obj};
    this.edit_data.detail.push(obj);
  }

  choose(value:string){

  }

}
